import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import './style.scss';

const DescriptionAccount = () => {
    const { t } = useTranslation();
    const { surname } = useSelector(({ user }) => user);

    return (
        <div className="description-account">
            <h3 className="title title--small">{t('menu.title', { surname })}</h3>
            <p>{t('menu.account.description')}</p>
            <img alt="freya" src="/assets/vasco-illustration.svg" />
        </div>
    );
};

export default DescriptionAccount;
